export const THEME = {
    DEFAULT: 'default',
    SECONDARY: 'secondary',
};
